/**
 * useBottleConnection.js
 * Generosity(TM) WTR App -- React binding for the persistent BLE singleton.
 * Drop into: frontend/src/hooks/useBottleConnection.js
 *
 * Any screen can call this to read the live connection state and drive it.
 * The connection itself lives in lib/bleManager.js at module scope, so it
 * survives this component (and every other) unmounting. Switching tabs no
 * longer drops the bottle.
 *
 * The action functions (connect, reconnect, disconnect, send, resetIntake,
 * setGoal, cancelScan) are stable module references, so passing them to
 * onClick handlers does not churn.
 */

import { useSyncExternalStore } from "react";
import * as ble from "../lib/bleManager";

export function useBottleConnection() {
  const snap = useSyncExternalStore(ble.subscribe, ble.getSnapshot, ble.getSnapshot);

  return {
    // live state
    status:     snap.status,      // idle | scanning | connected | error
    errMsg:     snap.errMsg,
    tele:       snap.tele,
    hist:       snap.hist,
    intake:     snap.intake,
    log:        snap.log,
    remembered: snap.remembered,
    deviceId:   snap.deviceId,
    deviceName: snap.deviceName,
    // actions (stable references)
    connect:     ble.connect,
    reconnect:   ble.reconnect,
    disconnect:  ble.disconnect,
    send:        ble.send,
    resetIntake: ble.resetIntake,
    setGoal:     ble.setGoal,
    cancelScan:  ble.cancelScan,
  };
}
